import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class UnarchiveOrders extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.UNARCHIVE_ORDER]);
  }
}

export default UnarchiveOrders;
